import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SelectionTypeIndexEnum } from 'enums/enums';
import { PeriodState } from 'types/PeriodSelectionTypes';

interface GeneralState {
  period: PeriodState,
  isContrast: boolean,
}

const initialState: GeneralState = {
  period: {
    year: { text: '', indexes: null },
    month: { text: '', indexes: null },
    quarterly: { text: '', indexes: null },
    active: SelectionTypeIndexEnum.year
  },
  isContrast: false,
}

export const general = createSlice({
  name: 'general',
  initialState,
  reducers: {
    setPeriod: (state, action: PayloadAction<PeriodState>) => {
      state.period = action.payload;
    },
    setIsContrast: (state, action: PayloadAction<boolean>)=>{
      state.isContrast = action.payload;
    },
  }
})

export const {
  setPeriod,
  setIsContrast,
} = general.actions;

export default general.reducer;